/**
 * @generated SignedSource<<494fb9fa823f6026a671936cdd6ba098>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimelineEntryTypeEnum = "education" | "work";
export type CreateTimelineEntryInput = {
  attributes: TimelineEntryAttributes;
  clientMutationId?: string | null | undefined;
};
export type TimelineEntryAttributes = {
  dateEnd?: string | null | undefined;
  dateStart?: string | null | undefined;
  description?: string | null | undefined;
  entryType?: TimelineEntryTypeEnum | null | undefined;
  instituteId?: string | null | undefined;
  place?: string | null | undefined;
  placeId?: string | null | undefined;
  skillsIds?: ReadonlyArray<string> | null | undefined;
  title?: string | null | undefined;
};
export type EditTimelineEntryDialog_CreateMutation$variables = {
  input: CreateTimelineEntryInput;
};
export type EditTimelineEntryDialog_CreateMutation$data = {
  readonly createTimelineEntry: {
    readonly timelineEntry: {
      readonly id: string;
      readonly user: {
        readonly " $fragmentSpreads": FragmentRefs<"TimelineEntriesField_User">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EditTimelineEntryDialog_CreateMutation = {
  response: EditTimelineEntryDialog_CreateMutation$data;
  variables: EditTimelineEntryDialog_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditTimelineEntryDialog_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTimelineEntryPayload",
        "kind": "LinkedField",
        "name": "createTimelineEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimelineEntry",
            "kind": "LinkedField",
            "name": "timelineEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TimelineEntriesField_User"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditTimelineEntryDialog_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTimelineEntryPayload",
        "kind": "LinkedField",
        "name": "createTimelineEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimelineEntry",
            "kind": "LinkedField",
            "name": "timelineEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimelineEntry",
                    "kind": "LinkedField",
                    "name": "timelineEntries",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entryType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "place",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Institute",
                        "kind": "LinkedField",
                        "name": "institute",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "worldRankRange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rankingYear",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Company",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "custom",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skills",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80267984aa90a50d7a0a2b2a5490cc80",
    "id": null,
    "metadata": {},
    "name": "EditTimelineEntryDialog_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation EditTimelineEntryDialog_CreateMutation(\n  $input: CreateTimelineEntryInput!\n) {\n  createTimelineEntry(input: $input) {\n    timelineEntry {\n      id\n      user {\n        ...TimelineEntriesField_User\n        id\n      }\n    }\n  }\n}\n\nfragment TimelineEntriesField_TimelineEntries on TimelineEntry {\n  id\n  entryType\n  place\n  title\n  dateStart\n  dateEnd\n  description\n  institute {\n    worldRankRange\n    rankingYear\n    id\n  }\n  company {\n    custom\n    id\n  }\n  skills {\n    id\n    name\n  }\n}\n\nfragment TimelineEntriesField_User on User {\n  profile {\n    industry {\n      id\n    }\n    id\n  }\n  timelineEntries {\n    ...TimelineEntriesField_TimelineEntries\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff968525859caa59a7b68dc736316dbb";

export default node;
